import { render, staticRenderFns } from "./HeaderService.vue?vue&type=template&id=53af851c&scoped=true"
import script from "./HeaderService.vue?vue&type=script&lang=js"
export * from "./HeaderService.vue?vue&type=script&lang=js"
import style0 from "./HeaderService.vue?vue&type=style&index=0&id=53af851c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53af851c",
  null
  
)

export default component.exports